module.exports = __webpack_public_path__ + "img/Mixed-fruits-460x295.f359ec85.jpg";